export default __webpack_public_path__ + "static/media/f25-focus-banner-desktop.0df580b8.jpg";